import { useState } from "react";
import { loadSONumberWiseLineItemReelTransfer } from "../services/storageLocationService";

const useGetSONumberWiseLineItemListForReelTransfer = (editID) => {
    const [lineItemList, setLineItemList] = useState([]);
    const [selectedLineItem, setSelectedLineItem] = useState([]);
    const [selectedLineItemID, setSelectedLineItemID] = useState([]);

    const [lineItemLoading, setLineItemLoading] = useState(false);

    // Fetch sales order numbers
    const fetchRequestIndentNumber = async (soNumber) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plant_id: 1,
            p_so_number: soNumber.so_number,
        };

        setLineItemLoading(true); // Show loader
        try {
            const data = await loadSONumberWiseLineItemReelTransfer(para);
            if (data && data.length > 0) {
                setLineItemList(data);


            }
        } catch (error) {
            console.error("Error fetching sales order numbers:", error);
        }
        finally {
            setLineItemLoading(false); // Hide loader after fetching
        }
    };


    // Function to update selected sales order number
    const loadSalesOrderWiseLineItemBySONumber = (soNumber) => {    
        fetchRequestIndentNumber(soNumber);
    };

    const clearLineitems = async () => {
        setLineItemList([]);
    }

    return {
        lineItemList,
        selectedLineItem,
        selectedLineItemID,
        setLineItemList,
        setSelectedLineItem,
        setSelectedLineItemID,
        loadSalesOrderWiseLineItemBySONumber,
        lineItemLoading, setLineItemLoading,
        clearLineitems,
    };
};

export default useGetSONumberWiseLineItemListForReelTransfer;
